import { ContactUs } from "components/AppendixScreen/ContactUs";
import { ErrorType } from "domain/error";
import { HOW_TO_CONTACT_US_TITLE } from "screens/Title.const";

type CommonHardStopProps = {
  headerText: string;
  toptext: string;
  errorType: ErrorType;
};

export const CommonHardStop = ({
  headerText,
  toptext,
  errorType,
}: CommonHardStopProps) => {
  document.title = HOW_TO_CONTACT_US_TITLE;
  return (
    <ContactUs header={headerText} toptext={toptext} errorType={errorType} />
  );
};
